// No three.js in this file: the panel's pages import it statically, and a single
// value from a module importing three puts the whole of three in the main bundle,
// for the member app too. The geometry is in crop.ts, behind the lazy viewer.

/**
 * What of a crag's model to keep: on each axis of its bounding box, the share
 * from the low side to the high one (0..1). Axes as the viewer shows them —
 * x left to right, y bottom to top, z back to front (the camera looks from +z).
 */
export interface CropBox {
  x: [number, number];
  y: [number, number];
  z: [number, number];
}

export const FULL_CROP: CropBox = { x: [0, 1], y: [0, 1], z: [0, 1] };

export const CROP_AXES = ['x', 'y', 'z'] as const;
export type CropAxis = (typeof CROP_AXES)[number];

export function isFullCrop(crop: CropBox) {
  return CROP_AXES.every((axis) => crop[axis][0] <= 0 && crop[axis][1] >= 1);
}
